module.exports = __webpack_public_path__ + "static/media/8_l_note_26.56_89.17.382ac3c2.png";